import toString from '../toString';
export default function stripLastNewLine(value) {
  var stringValue = toString(value);
  var length = stringValue.length;
  return length > 0 && stringValue[length - 1] === '\n' ? stringValue.slice(0, length - 1) : stringValue;
}